// import { useQuery } from '@tanstack/react-query';
// import sosLogServices from '../services/sos-log.service';

// export const useSosLog = (sosLogId) => {
//   return useQuery({
//     queryKey: ['sos-log', sosLogId],
//     queryFn: () => sosLogServices.getSosLogById(sosLogId),
//     enabled: !!sosLogId,
//     staleTime: 30 * 1000,
//     gcTime: 5 * 60 * 1000,
//     refetchOnWindowFocus: true,
//   });
// };


import { useQuery } from '@tanstack/react-query';
import sosLogServices from '../services/sos-log.service';

/**
 * Reusable API error parser
 */
const parseApiError = (error) => {
  return {
    message:
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Something went wrong',

    status: error?.response?.status || 500,

    errors: error?.response?.data?.errors || [],
  };
};

/**
 * Get single SOS log
 */
export const useSosLog = (sosLogId) => {
  return useQuery({
    queryKey: ['sos-log', sosLogId],

    queryFn: async () => {
      try {
        return await sosLogServices.getSosLogById(sosLogId);
      } catch (error) {
        throw parseApiError(error);
      }
    },

    enabled: !!sosLogId,

    staleTime: 30 * 1000, // 30 seconds
    gcTime: 5 * 60 * 1000, // 5 minutes

    retry: 1,

    refetchOnWindowFocus: true,
  });
};